import '../../assets/authcss.css';
import {useState} from 'react';
import {Link} from 'react-router';
import {authservices} from '../../services/authServices';
import { Toast } from 'primereact/toast';
import {useRef} from 'react';
import { Submissionbtn } from "../../components/buttons";
const Login = () =>{ 
const toast = useRef(null);
const [initialvalues,setValues] = useState({
	 'email':'',
	 'password':''
});
const [submitted,setSubmitted] = useState(true);
	

const onChange = (e) =>{
    setValues((previousdata)=> {
       return {
		...previousdata,
		[e.target.name] : e.target.value 			
	   }
	});  	  
}	
	
 const onSubmit = (e) =>{
    e.preventDefault();
	setSubmitted(false);
	// console.log("onsubmit");
    // console.log(initialvalues);
	authservices.login(initialvalues).then((response)=>{
		// console.log("response data");
		 setSubmitted(true);
		console.log(response);	
		if(response.status == 200){
			toast.current.show({ severity: 'success', summary: 'Login', detail: 'Successfully logged in!' }) 
			const token = response.data.token;
			const userdata = JSON.stringify(response.data.userdata);
			const companydata = JSON.stringify(response.data.company_data);
			const logo = JSON.stringify(response.data.logo);
			const permissions = JSON.stringify(response.data.permissons);
			localStorage.setItem('token',token); 
			localStorage.setItem('userdata',userdata); 
			localStorage.setItem('permissons',permissions);
			localStorage.setItem('companydata',companydata);
			localStorage.setItem('logo',logo);


			window.location.href = '/';
		  }else{
			 setSubmitted(true);
			toast.current.show({ severity: 'error', summary: 'Login', detail: response.data.message }) 
		 }     
	}).catch((error)=>{
		 setSubmitted(true);
		console.log(error);
	});
 }	


  return(
    <>
	<Toast ref={toast} />
	{/* <div className="login bg-primary">
		<div className="wrapper wrapper-login">
			<form onSubmit={(e) => onSubmit(e)} class="login100-form validate-form">
				<div className="container container-login animated fadeIn" style={{display: 'block'}}>
					<h3 className="text-center">Sign In</h3>
					<div className="login-form">
					<div className="form-sub">
						<div className="form-floating form-floating-custom mb-3">
						<input id="email" name="email" type="text" className="form-control" placeholder="email" required="" onChange={(e)=>onChange(e)} />
						<label for="Email">Email</label>
						</div>
						<div className="form-floating form-floating-custom mb-3">
						<input id="password" name="password" type="password" className="form-control" placeholder="password" required="" onChange={(e)=>onChange(e)} />
						<label for="password">Password</label>
						<div className="show-password">
							<i className="icon-eye"></i>
						</div>
						</div>
					</div>
					<div className="form-action mb-3">
						<button type='submit' class="btn btn-primary w-100 btn-login">
							Sign in
						</button>
					</div>
					<div className="d-flex justify-content-between" style={{ padding: "0px 10px" }}>
					<a href="/forgot-password" className="text-primary small">
						Forgot Password?
					</a>
					<a href="/register" className="text-primary small">
						Sign Up
					</a>
				</div>
					</div>
				</div>
			</form>
		</div>
	</div> */}
	<div className="login-page">
		<div className="login-left">
			<div class="gradient-bubble"></div>
			<div class="gradient-bubble1"></div>
			<img
                                    src="utan logo.png"
                                    alt="navbar brand"
                                    className="navbar-brand"
                                    height="80"
                                />
			<h1>Welcome Back</h1>
			<p>Access your dashboard</p>
		</div>
		<div className="login-right">
			<form onSubmit={onSubmit}>
			<h2>Sign In</h2>
			<input type="text" name="email" placeholder="Email" onChange={onChange} required />
			<input type="password" name="password" placeholder="Password" onChange={onChange} required />
			{/* <button type="submit">Sign In</button> */}
			 <Submissionbtn issaved={submitted} label={'Sign In'} label2={'Signing'}/>
			<div className="links">
				<a href="/forgot-password">Forgot Password?</a>
				<a href="/register">Sign Up</a>
			</div>
			</form>
		</div>
	</div>

    </>
  );
}

export default Login;